<!-- <app-gallery [style.width.px]=this.drawingHolderWidth [galleryId]="'1'" [section]="item.floor.id+'floordrawing'" [autoPlay]="true" [showThumbs]="true" -->
<app-gallery @anim *ngIf="!ifFloorIdIsFloorNumber(item)" [galleryId]="'1'" [section]="item+'floordrawing'"
             [autoPlay]="true" [showThumbs]="true"
             [resizeDrag]="true" class="floor-gallery simple-drawing-floor images"></app-gallery>

<app-gallery @anim *ngIf="!ifFloorIdIsFloorNumber(item)" [galleryId]="'1'" [section]="item+'floordrawing-SVG'"
             [autoPlay]="true" [showThumbs]="true"
             class="floor-gallery svg-drawing-floor images"></app-gallery>

<app-gallery @anim *ngIf="ifFloorIdIsFloorNumber(item)" [galleryId]="'1'" [section]="item+'floordrawing'+buildUid"
             [autoPlay]="true" [showThumbs]="true"
             [resizeDrag]="true" class="floor-gallery simple-drawing-floor images"></app-gallery>

<app-gallery @anim *ngIf="ifFloorIdIsFloorNumber(item)" [galleryId]="'1'" [section]="item+'floordrawing-SVG'+buildUid"
             [autoPlay]="true" [showThumbs]="true"
             class="floor-gallery svg-drawing-floor images"></app-gallery>
